import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const WoodmenLifeMagazineIcon: React.FC<WLIconProps> = ({
  variant,
  ...rest
}) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 200 200" {...rest} __css={styles}>
      <desc id="svgdescWLMagazine">magazine page</desc>
      <circle cx="100" cy="100" r="84.3" className="background" />
      <path className="accent" d="M113.7 77.5H131v21.4h-17.3z" />
      <path
        d="M141 56.2H78.7C77.4 52 74.2 49 70.4 49c-4.7 0-8.6 4.8-8.6 10.6v73c0 8.8 5.8 16 13 16h57.6a1.6 1.6 0 0 0 1.5-1.8v-5.3h7.2a1.6 1.6 0 0 0 1.4-1.8V58a1.6 1.6 0 0 0-1.4-1.8Zm-43.2 7h17.3a1.8 1.8 0 0 1 0 3.6H97.8a1.8 1.8 0 0 1 0-3.5ZM86.3 74h20.2a1.8 1.8 0 0 1 0 3.6H86.3a1.8 1.8 0 0 1 0-3.6Zm0 7.1h20.2a1.8 1.8 0 0 1 0 3.6H86.3a1.8 1.8 0 0 1 0-3.6Zm0 7.1h20.2a1.8 1.8 0 0 1 0 3.6H86.3a1.8 1.8 0 0 1 0-3.6Zm0 7.2h20.2a1.8 1.8 0 0 1 0 3.5H86.3a1.8 1.8 0 0 1 0-3.5Zm0 7h20.2a1.8 1.8 0 0 1 0 3.6H86.3a1.8 1.8 0 0 1 0-3.5ZM64.7 59.8c0-3.9 2.6-7 5.7-7s5.8 3.1 5.8 7v66.9a7.3 7.3 0 0 0-11.5 0Zm66.3 85.4H74.8c-5.5 0-10-5.4-10.1-12l.8-2a5.2 5.2 0 0 1 10 0l.7 2c.3 4.8 3.4 8.5 7.2 8.5H131Zm1.4-17.8H86.3a1.8 1.8 0 0 1 0-3.5h46.1a1.8 1.8 0 0 1 0 3.5Zm0-7H86.3a1.8 1.8 0 0 1 0-3.6h46.1a1.8 1.8 0 0 1 0 3.5Zm0-7.2H86.3a1.8 1.8 0 0 1 0-3.6h46.1a1.8 1.8 0 0 1 0 3.6Zm1.5-12.4a1.6 1.6 0 0 1-1.5 1.7h-20.2a1.6 1.6 0 0 1-1.4-1.7v-25a1.6 1.6 0 0 1 1.4-1.7h20.2a1.6 1.6 0 0 1 1.5 1.8Z"
        className="accent"
      />
    </Icon>
  );
};

export default WoodmenLifeMagazineIcon;
